import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/feature/SEOMeta';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestEpisodes from './components/LatestEpisodes';
import VarietyShows from './components/VarietyShows';
import AnimeSection from './components/AnimeSection';
import DocumentarySection from './components/DocumentarySection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const { t } = useTranslation();

  return (
    <>
      <SEOMeta
        title="国产在线观看 - 高清免费影视平台"
        description="国产在线观看精选海量高清影视内容，涵盖国产电影、电视剧、综艺、动漫等全品类资源。无需下载，即点即播，支持多设备流畅观看，每日更新最新国产剧集，打造最佳国产在线观看体验。"
        keywords="国产在线观看,国产电视剧在线观看,国产电影免费在线观看,国产高清在线观看,最新国产剧在线观看,国产综艺在线观看,国产动漫在线观看"
        canonicalUrl="https://dywatch.github.io/"
        ogImage="https://readdy.ai/api/search-image?query=Chinese%20online%20streaming%20platform%20brand%20image%20with%20cinematic%20film%20elements%20and%20modern%20design%2C%20warm%20lighting%2C%20professional%20graphic%20design%2C%20clean%20composition&width=1200&height=630&seq=og-homepage&orientation=landscape"
      />

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '国产在线观看',
            url: 'https://dywatch.github.io',
            description: '国产在线观看精选海量高清影视内容，涵盖国产电影、电视剧、综艺、动漫等全品类资源',
            sameAs: [],
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+86-10-8888-6666',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
          }),
        }}
      />

      {/* WebSite Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '国产在线观看',
            url: 'https://dywatch.github.io',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://dywatch.github.io/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      {/* WebPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '国产在线观看 - 高清免费影视平台',
            description: '国产在线观看精选海量高清影视内容，涵盖国产电影、电视剧、综艺、动漫等全品类资源',
            url: 'https://dywatch.github.io/',
            isPartOf: {
              '@type': 'WebSite',
              name: '国产在线观看',
            },
          }),
        }}
      />

      <Navbar />

      <main>
        <HeroBanner />
        <CategoryNav />
        <HotRecommend />
        <LatestEpisodes />
        <VarietyShows />
        <AnimeSection />
        <DocumentarySection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}